import React from "react";
import {
  CheckSquareOutlined,
  CloseSquareOutlined,
  EditOutlined,
  MinusSquareOutlined,
  PieChartOutlined,
  PlayCircleOutlined,
  SendOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { confirmModalPreviewMethod, navigateToPage } from "./helpers";
import {
  deletInsuranceAction,
  deletShop,
  editShopToActiveOrInactiveAction,
  getAllShops,
  getAllStaff,
  resendOnboardingEmail,
  updateUserAction,
} from "@/redux/page/action";
import ConfirmationModalCheckBox from "@/components/ConfirmationModalCheckBox";

export const fallbackImage =
  "data:image/png;base64,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";

export const emptyImageLabels = {
  frontSide: "",
  backSide: "",
  rightSide: "",
  leftSide: "",
  exteriorRoof: "",
  engine: "",
  odometer: "",
  frontInterior: "",
  backInterior: "",
  rearCompartments: "",
};

export const imagesLabels = Object.freeze({
  frontSide: "Front Side",
  backSide: "Back Side",
  rightSide: "Right Side",
  leftSide: "Left Side",
  backInterior: "Back Interior",
});

export const inspectorImagesLabels = Object.freeze({
  ...imagesLabels,
  exteriorRoof: "Exterior Roof",
  engine: "Engine",
  odometer: "Odometer",
  frontInterior: "Front Interior",
  backInterior: "Back Interior",
  rearCompartments: "Rear Compartment",
  others1: "Others 1",
  others2: "Others 2",
  others3: "Others 3",
  others4: "Others 4",
  others5: "Others 5",
});

export const placeholderImages = Object.freeze({
  frontSide: "/assets/images/Frontside.png",
  backSide: "/assets/images/Backside.png",
  rightSide: "/assets/images/Rightside.png",
  leftSide: "/assets/images/Leftside.png",
  exteriorRoof: "/assets/images/ExteriorRoof.png",
  engine: "/assets/images/Engine.png",
  odometer: "/assets/images/Odometer.png",
  frontInterior: "/assets/images/FrontInterior.png",
  backInterior: "/assets/images/BackInterior.png",
  rearCompartments: "/assets/images/RearCompartment.png",
  others1: "/assets/images/Frontside.png",
  others2: "/assets/images/Frontside.png",
  others3: "/assets/images/Frontside.png",
  others4: "/assets/images/Frontside.png",
  others5: "/assets/images/Frontside.png",
});

export const roles = Object.freeze({
  SHOPOWNER: "shopowner",
  ADMIN: "admin",
  APPRAISALWRITER: "appraisal_writer",
});

export const acceptedImgTypes = [
  "image/jpeg",
  "image/jpg",
  "image/apng",
  "image/jfif",
  "image/pjpeg",
  "image/pjp",
  "image/png",
  "image/webp",
];
export const UploadImgLimit = 5; //in Mbs

export const animationConfig = {
  type: "spring",
  damping: 20,
  stiffness: 100,
};

export const commonStatus = Object.freeze({
  IS_EDITABLE: true,
});

export const appraisalStatus = Object.freeze({
  NEW: "NEW",
  IN_PROGRESS: "IN PROGRESS",
  REJECTED: "REJECTED",
  OBJECTION: "OBJECTION",
  CANCELLED: "CANCELLED",
  AWAITING_SHOP_APPROVAL: "AWAITING SHOP APPROVAL",
  APPROVED_BY_SHOP: "APPROVED BY SHOP",
  REJECTED_BY_SHOP: "REJECTED BY SHOP",
  COMPLETED: "COMPLETED",
  UPLOADED_TO_INSURANCE: "UPLOADED TO INSURANCE",
  TOTAL_LOSS: "TOTAL LOSS",
  APPROVED_BY_INSURANCE: "APPROVED BY INSURANCE",
  REJECTED_BY_INSURANCE: "REJECTED BY INSURANCE",
});

export const statusDependentOnCurrentStatus = Object.freeze({
  NEW: [
    {
      text: "Set to In-Progress",
      status: appraisalStatus.IN_PROGRESS,
      icon: PlayCircleOutlined,
      // route: "/appraisal",
    },
    // {
    //     text: 'Object on Request',
    //     status: appraisalStatus.OBJECTION,
    //     icon: StopOutlined,
    //     route: "/appraisal/rejection-form"
    // },
    {
      text: "Cancel Request",
      status: appraisalStatus.CANCELLED,
      icon: CloseSquareOutlined,
      route: "/appraisal/cancel-form",
    },
  ],
  IN_PROGRESS: [
    {
      text: "Reject Request",
      status: appraisalStatus.REJECTED,
      icon: StopOutlined,
      route: "/appraisal/rejection-form",
    },
    {
      text: "Cancel Request",
      status: appraisalStatus.CANCELLED,
      icon: CloseSquareOutlined,
      route: "/appraisal/cancel-form",
    },
    {
      text: "Send Estimate for Approval",
      status: appraisalStatus.AWAITING_SHOP_APPROVAL,
      icon: PieChartOutlined,
      // route: "/appraisal",
      noConfirmation: true,
    },
  ],
  REJECTED: [
    {
      text: "Set to In-Progress",
      status: appraisalStatus.IN_PROGRESS,
      icon: PlayCircleOutlined,
      // route: "/appraisal",
    },
    {
      text: "Cancel Request",
      status: appraisalStatus.CANCELLED,
      icon: CloseSquareOutlined,
      route: "/appraisal/cancel-form",
    },
    // {
    //   text: "Upload to Insurance",
    //   status: appraisalStatus.UPLOADED_TO_INSURANCE,
    //   icon: CheckSquareOutlined,
    //   // route: "/appraisal",
    // },
  ],
  APPROVED_BY_SHOP: [
    {
      text: "Cancel Request",
      status: appraisalStatus.CANCELLED,
      icon: CloseSquareOutlined,
      route: "/appraisal/cancel-form",
    },
    {
      text: "Reject Request",
      status: appraisalStatus.REJECTED,
      icon: StopOutlined,
      route: "/appraisal/rejection-form",
    },
    {
      text: "Upload to Insurance",
      status: appraisalStatus.UPLOADED_TO_INSURANCE,
      icon: CheckSquareOutlined,
      // route: "/appraisal",
      noConfirmation: true,
    },
  ],
  REJECTED_BY_SHOP: [
    {
      text: "Reject Request",
      status: appraisalStatus.REJECTED,
      icon: StopOutlined,
      route: "/appraisal/rejection-form",
    },
    {
      text: "Cancel Request",
      status: appraisalStatus.CANCELLED,
      icon: CloseSquareOutlined,
      route: "/appraisal/cancel-form",
    },
    {
      text: "Send Estimate for Approval",
      status: appraisalStatus.AWAITING_SHOP_APPROVAL,
      icon: PieChartOutlined,
      // route: "/appraisal",
      noConfirmation: true,
    },
  ],
  UPLOADED_TO_INSURANCE: [
    {
      text: "Cancel Request",
      status: appraisalStatus.CANCELLED,
      icon: CloseSquareOutlined,
      route: "/appraisal/cancel-form",
    },
    {
      text: "Total Loss",
      status: appraisalStatus.TOTAL_LOSS,
      icon: StopOutlined,
      // route: "/appraisal",
      // noConfirmation: true,
    },
    {
      text: "Approved By Insurance",
      status: appraisalStatus.APPROVED_BY_INSURANCE,
      icon: CheckSquareOutlined,
      // route: "/appraisal",
      noConfirmation: true,
    },
    {
      text: "Rejected By Insurance",
      status: appraisalStatus.REJECTED_BY_INSURANCE,
      icon: StopOutlined,
      route: "/appraisal/rejection-form",
    },
  ],
  AWAITING_SHOP_APPROVAL: [
    {
      text: "Cancel Request",
      status: appraisalStatus.CANCELLED,
      icon: CloseSquareOutlined,
      route: "/appraisal/cancel-form",
    },
    // CANCELLED: "CANCELLED",
    // APPROVED_BY_INSURANCE: "APPROVED BY INSURANCE",
    // REJECTED_BY_INSURANCE: "REJECTED BY INSURANCE",
  ],
});

export const appraisalStatusNotes = Object.freeze({
  NEW: "Appraisal request created.",
  IN_PROGRESS: "Appraisal request in progress.",
  FEEDBACK: "Photo feedback provided on appraisal request.",
  REJECTED: "Appraisal request rejected.",
  OBJECTION: "Appraisal request under objection.",
  CANCELLED: "Appraisal request cancelled.",
  AWAITING_SHOP_APPROVAL: "Waiting for shop approval.",
  APPROVED_BY_SHOP: "Appraisal request approved by shop.",
  REJECTED_BY_SHOP: "Appraisal request rejected by shop.",
  UPLOADED_TO_INSURANCE: "Appraisal's estimates uploaded to insurance.",
  COMPLETED: "Appraisal request completed.",
  TOTAL_LOSS: "Appraisal request is in total loss.",
  APPROVED_BY_INSURANCE: "Appraisal request approved by insurance.",
  REJECTED_BY_INSURANCE: "Appraisal request rejected by insurance.",
});

export const photoQualityRadioConstants = Object.freeze({
  UNACCEPTABLE: "Unacceptable",
  POOR: "Poor",
  FAIR: "Fair",
  GOOD: "Good",
});

export const shopCapabilities = [
  "Full frame machine in house",
  "Plastic Welding Equipment",
  "Aluminium Equipment",
  "Technical certifications",
  "Shop certifications",
  "Scan tools onsite",
  "In-house paint protection",
  "Glass services",
  "Paintless Dent Removal",
];

export const statusModalData = [
  {
    text: "Set to In-Progress",
    status: appraisalStatus.IN_PROGRESS,
    icon: PlayCircleOutlined,
    route: "/appraisal",
  },
  {
    text: "Reject Request",
    status: appraisalStatus.OBJECTION,
    icon: StopOutlined,
    route: "/appraisal/rejection-form",
  },
  {
    text: "Cancel Request",
    status: appraisalStatus.CANCELLED,
    icon: CloseSquareOutlined,
    route: "/appraisal/cancel-form",
  },
];

export const rejectionQualityOfPhotos = Object.freeze([
  {
    key: "Unacceptable",
    label: "Unacceptable: Reject request as request cannot be completed.",
  },
  {
    key: "Poor",
    label: "Poor: Can complete estimate but images are of low quality.",
  },
  {
    key: "Fair",
    label: "Fair: Can complete estimate but may have approval challenges.",
  },
  {
    key: "Good",
    label: "Good: can complete a quality estimate.",
  },
]);

export const rejectionQualityCheckBoxes = Object.freeze([
  {
    key: "Unacceptable",
    options: [
      "Missing photos required to move ahead with the estimate.",
      "Blurry Images.",
      "Cannot see what the shop is requesting (replacement of parts).",
      "Missing Invoices.",
      "Poor photo angles.",
    ],
  },
  {
    key: "Poor",
    options: [
      "Poor lighting.",
      "Poor angles.",
      "Up close images - cannot verify panels or trims.",
      "Missing portion of vehicle required for estimate.",
      "Dirty vehicle.",
      "Dismantle not completed or attempted.",
    ],
  },
  {
    key: "Fair",
    options: [
      "Missing identification of prior damage.",
      "Missing in-progress photos for finals.",
    ],
  },
  {
    key: "Good",
    options: [
      "Missing photos required to move ahead with the estimate.",
      "Blurry Images.",
      "Cannot see what the shop is requesting (replacement of parts).",
      "Missing Invoices.",
      "Poor photo angles.",
    ],
  },
]);

export const feedbackMessages = Object.freeze({
  REJECTED:
    "Your request is rejected because the photos didn't match our guidelines. Detailed feedback below:",
  OBJECTION:
    "Your request is under objection because the photos didn't match our guidelines. Detailed feedback below:",
  IN_PROGRESS:
    "Your request is under objection because the photos didn't match our guidelines. Detailed feedback below:",
  CANCELLED:
    "Your request was cancelled because it didn't match our guidelines. Detailed feedback below:",
  AWAITING_SHOP_APPROVAL:
    "Here's the estimate - we need your approval on this.",
  REJECTED_BY_SHOP: "Estimate is rejected by shop",
  // APPROVED_BY_SHOP: "Estimate approved by shop"
  COMPLETED: "",
});

export const navigatePageStates = Object.freeze({
  IS_REUPLOAD_PAGE: "isReuploadPage",
});

export const fileLogos = Object.freeze({
  document: "/assets/images/wordLogo.png",
  sheet: "/assets/images/excelLogo.png",
  pdf: "/assets/images/pdfLogo.png",
  text: "/assets/images/textLogo.png",
  default: fallbackImage,
});

export const acceptedFileTypes = Object.freeze([
  "text/plain",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
]);

export const doNotShowUpdateAndFeedbackBtn = Object.freeze([
  "CANCELLED",
  // "AWAITING SHOP APPROVAL",
  "COMPLETED",
  "REJECTED BY INSURANCE",
  "APPROVED BY INSURANCE",
  "TOTAL LOSS",
]);

export const doNotShowCancelAndEditBtn = Object.freeze([
  "CANCELLED",
  "COMPLETED",
  "UPLOADED TO INSURANCE",
  // "AWAITING SHOP APPROVAL",
  "APPROVED BY INSURANCE",
  "REJECTED BY INSURANCE",
  "TOTAL LOSS",
]);

export const showRatingBtn = Object.freeze([
  "COMPLETED",
  "UPLOADED TO INSURANCE",
  "APPROVED BY INSURANCE",
  "REJECTED BY INSURANCE",
  "TOTAL LOSS",
]);

export const estimateMessages = Object.freeze({
  AWAITING_SHOP_APPROVAL: "Estimate provided by writer: ",
  APPROVED_BY_SHOP: "Approved Estimate: ",
  REJECTED_BY_SHOP: "Estimate provided by writer:",
});

export const showApproveAndRejectBtn = Object.freeze([
  appraisalStatus?.AWAITING_SHOP_APPROVAL,
]);

export const navigateAndUpdateStatus = Object.freeze([
  appraisalStatus.CANCELLED,
  appraisalStatus.REJECTED,
  appraisalStatus.REJECTED_BY_INSURANCE,
]);

export const updateStatusOnOk = Object.freeze([
  appraisalStatus.COMPLETED,
  appraisalStatus.UPLOADED_TO_INSURANCE,
  appraisalStatus.IN_PROGRESS,
  appraisalStatus.NEW,
  appraisalStatus.TOTAL_LOSS,
]);

export const approvedOrRejectChatStatus = Object.freeze([
  appraisalStatus.AWAITING_SHOP_APPROVAL,
  appraisalStatus.APPROVED_BY_SHOP,
  appraisalStatus.APPROVED_BY_INSURANCE,
  appraisalStatus.REJECTED_BY_INSURANCE,
  appraisalStatus.REJECTED_BY_SHOP,
  appraisalStatus.UPLOADED_TO_INSURANCE,
  appraisalStatus.TOTAL_LOSS,
]);

export const hideMessageInputForStatus = Object.freeze([
  appraisalStatus.CANCELLED,
  appraisalStatus.COMPLETED,
  appraisalStatus.APPROVED_BY_INSURANCE,
  appraisalStatus.REJECTED_BY_INSURANCE,
  appraisalStatus.TOTAL_LOSS,
]);

export const approvedOrRejectChatMessage = Object.freeze({
  AWAITING_SHOP_APPROVAL: "Estimate provided by writer: ",
  APPROVED_BY_SHOP: "Approved estimate by shop: ",
  APPROVED_BY_INSURANCE: "Approved estimate by insurance: ",
  UPLOADED_TO_INSURANCE: "Estimate uploaded to insurance:  ",
  REJECTED_BY_INSURANCE: "Estimate rejected by insurance:  ",
  REJECTED_BY_SHOP: "Suggested estimate by shop: ",
});

export const shopProfileCheckBoxes = [
  "Full frame machine in house.",
  "Plastic Welding Equipment.",
  "Aluminium Equipment.",
  "Technical certifications.",
  "Scan tools onsite.",
  "In-house paint protection.",
  "Glass services.",
  "Paintless Dent Removal.",
];

export const appraisalMenuItems = [
  {
    key: 1,
    label: "Edit",
    onClick: () => console.log("EDIT"),
  },
];
const show = () => {
  console.log("SHOWING");
};

export const shopMenuItems = ({ shop, updateUserRef, setRowRecord }) => {
  return shop?.isActive
    ? [
        {
          key: 1,
          action: "edit",
          label: "Edit Shop",
          icon: React.createElement(EditOutlined),
          handleClick: (id, navigate) => {
            if (navigate) {
              navigateToPage(
                "/settings/add-shop",
                { id, isAdmin: true },
                navigate
              );
            }
          },
        },
        {
          key: 2,
          action: shop?.isActive ? "disable" : "enable",
          label: shop?.isActive ? "Disable Shop" : "Enable Shop",
          icon: shop?.isActive
            ? React.createElement(MinusSquareOutlined)
            : React.createElement(CheckSquareOutlined),
          handleClick: (id, listing, dispatch) => {
            if (dispatch) {
              if (shop?.isActive) {
                setRowRecord(shop);
                updateUserRef.current.showModal();
                return;
              }
              updateAndGetAllShops({
                dispatch,
                id,
                isActive: true,
                disablePocs: false,
              });
            }
          },
        },
      ]
    : [
        {
          key: 1,
          action: shop?.isActive ? "disable" : "enable",
          label: shop?.isActive ? "Disable Shop" : "Enable Shop" ,
          icon: shop?.isActive
            ? React.createElement(MinusSquareOutlined)
            : React.createElement(CheckSquareOutlined),
          handleClick: (id, listing, dispatch) => {
            if (dispatch) {
              if (shop?.isActive) {
                setRowRecord(shop);
                updateUserRef.current.showModal();
                return;
              }
              updateAndGetAllShops({
                dispatch,
                id,
                isActive: true,
                disablePocs: false,
              });
            }
          },
        },
      ];
};

export const updateAndGetAllShops = async ({
  dispatch,
  id,
  isActive,
  disablePocs,
}) => {
  await dispatch(
    editShopToActiveOrInactiveAction(id, { isActive: isActive, disablePocs })
  );
  dispatch(
    getAllShops({
      pageNo: 1,
      pageSize: 10,
      status: "",
      isActive: !isActive,
    })
  );
};

export const staffMenuItems = (record) => {
  return record?.isVerified === false
    ? [
        {
          key: 1,
          action: "edit",
          label: "Edit Staff",
          icon: React.createElement(EditOutlined),
          handleClick: (id, navigate) => {
            if (navigate) {
              navigateToPage(
                "/settings/add-staff",
                { id, isAdmin: true },
                navigate
              );
            }
          },
        },
        {
          key: 2,
          action: "send-email",
          label: "Resend Email",
          icon: React.createElement(SendOutlined),
          handleClick: (id, listing, dispatch) => {
            dispatch(resendOnboardingEmail(id));
          },
        },
      ]
    : [
        {
          key: 1,
          action: "edit",
          label: "Edit Staff",
          icon: React.createElement(EditOutlined),
          handleClick: (id, navigate) => {
            if (navigate) {
              navigateToPage(
                "/settings/add-staff",
                { id, isAdmin: true },
                navigate
              );
            }
          },
        },
      ];
};

const updateAndFetchUsers = async ({ dispatch, isActive, id, record }) => {
  await dispatch(
    updateUserAction({
      id,
      name: record?.name,
      phone: record?.phone,
      isActive: isActive,
    })
  );
  dispatch(
    getAllStaff({
      pageNo: 1,
      pageSize: 10,
      status: "",
      role: `${roles.SHOPOWNER}`,
      shopOwnerTable: true,
      isActive: !isActive,
    })
  );
};

const dropdownItems = ({ record }) => {
  return [
    {
      key: 1,
      action: "edit",
      label: "Edit Shop User",
      icon: React.createElement(EditOutlined),
      handleClick: (id, navigate) => {
        if (navigate) {
          navigateToPage(
            "/settings/add-staff",
            { id, isCreateShopUser: true, isAdmin: true },
            navigate
          );
        }
      },
    },
    {
      key: 2,
      action: record?.isActive ? "disable" : "enable",
      label: record?.isActive ? "Disable Shop User" : "Enable Shop User",
      icon: record?.isActive
        ? React.createElement(MinusSquareOutlined)
        : React.createElement(CheckSquareOutlined),
      handleClick: (id, listing, dispatch) => {
        if (dispatch) {
          record?.isActive
            ? confirmModalPreviewMethod({
                title: "Do you want to disable shop user?",
                onConfirmFunction: () => {
                  updateAndFetchUsers({
                    dispatch,
                    isActive: false,
                    record,
                    id,
                  });
                },
              })
            : updateAndFetchUsers({ dispatch, isActive: true, record, id });
        }
      },
    },
    {
      key: 3,
      action: "send-email",
      label: "Resend Email",
      icon: React.createElement(SendOutlined),
      handleClick: (id, listing, dispatch) => {
        dispatch(resendOnboardingEmail(id));
      },
    },
  ];
};

const conditionalDropdownOptions = (record) => {
  const _dropdownItems = dropdownItems({ record });
  if (record?.isActive) {
    if (record?.isVerified === false) {
      return _dropdownItems;
    }
    return [_dropdownItems[0], _dropdownItems[1]];
  } else if (!record?.isActive) {
    return [_dropdownItems[1]];
  }
};

export const shopUserMenuItems = (record) => {
  return conditionalDropdownOptions(record);
};

export const roleMenuItems = [
  {
    key: 1,
    action: "edit",
    label: "Edit Role",
    icon: React.createElement(EditOutlined),
    handleClick: (id, navigate) => {
      if (navigate) {
        navigateToPage("/settings/edit-role", { id }, navigate);
      }
    },
  },
];

export const insuranceMenuItems = [
  {
    key: 1,
    action: "edit",
    label: "Edit Insurance",
    icon: React.createElement(EditOutlined),
    handleClick: (id, navigate) => {
      if (navigate) {
        navigateToPage("/settings/edit-insurance", { id }, navigate);
      }
    },
  },
  {
    key: 2,
    action: "delete",
    label: "Delete Insurance",
    icon: React.createElement(MinusSquareOutlined),
    handleClick: (id, listing, dispatch) => {
      if (dispatch) {
        confirmModalPreviewMethod({
          title: "Do you want to delete?",
          onConfirmFunction: () => {
            dispatch(deletInsuranceAction(id, listing));
          },
        });
      }
    },
  },
];

export const StatusClassMap = Object.freeze({
  NEW: "status-new",
  IN_PROGRESS: "status-in-progress",
  REJECTED: "status-rejected",
  CANCELLED: "status-cancelled",
  UPLOADED_TO_INSURANCE: "status-completed",
  TOTAL_LOSS: "status-total-loss",
  COMPLETED: "status-completed",
  AWAITING_SHOP_APPROVAL: "status-awaiting-shop-approval",
  APPROVED_FROM_INSURANCE: "status-approved-from-insurance",
});

export const payModeConst = Object.freeze({
  CUSTOMER_PAY: "Customer Pay",
  INSURANCE_PAY: "Insurance",
});

export const randomBarColors = Object.freeze([
  "#4285F4", // Blue
  "#DB4437", // Red
  "#F4B400", // Yellow
  "#0F9D58", // Green
  "#66A8FF", // Light Blue
  "#C1351D", // Dark Red
  "#FFD700", // Bright Yellow
  "#00897B", // Teal Green
  "#bd4158", // Dull Crimson
]);

export const allowedImagesType = Object.freeze([
  "image/jpeg",
  "image/png",
  "image/gif",
]);

export const sortOrderObject = Object.freeze({
  ascend: "asc",
  descend: "desc",
});
export const reAssignMenuItems = Object.freeze([
  {
    key: 1,
    label: "Re-Assign Writer",
  },
]);

export const hourDayEnum = Object.freeze({
  hours: "hours",
  days: "days",
});

export const sortOrders = Object.freeze({
  ASCEND: "ascend",
  DESCEND: "descend",
});

export const ratingStars = Object.freeze([
  {
    label: "5 Stars",
    value: 5,
  },
  {
    label: "4 Stars",
    value: 4,
  },
  {
    label: "3 Stars",
    value: 3,
  },
  {
    label: "2 Stars",
    value: 2,
  },
  {
    label: "1 Stars",
    value: 1,
  },
]);

export const PDF_FILE_TYPE = "application/pdf";

export const SHOP_PATH_NAME = "/settings/add-shop";
